export default __webpack_public_path__ + "static/media/individual-account.d7c6a77f.jpg";